<template>
  <div class="bg-white p-4 shadow-xl rounded sm:p-8 sm:w-1/2 md:w-1/3 w-full">
    <h6 class="font-serif font-bold text-2xl text-red-600 mb-4">
      Your IPv4 Address
    </h6>
    <form class="w-full">
      <div class="flex items-center border-b border-b-2 border-red-600 py-2">
        <input
          class="appearance-none bg-transparent border-none w-full text-gray-700 mr-3 py-1 px-2 leading-tight focus:outline-none text-xl"
          type="text"
          disabled
          v-model="address"
        />
        <button
          :class="buttonClasses"
          type="button"
          v-clipboard:copy="address"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
        >
          <check-circle-icon v-if="copied === true"></check-circle-icon>
          <alert-circle-icon v-else-if="copied === false"></alert-circle-icon>
          <copy-icon v-else></copy-icon>
        </button>
      </div>
    </form>
  </div>
</template>

<script>
  import { CopyIcon, CheckCircleIcon, AlertCircleIcon } from "vue-feather-icons";

  export default {
    name: "IPv4",
    data() {
      return {
        address: "",
        copied: null,
        buttonClasses:
          "flex-shrink-0 bg-red-600 hover:bg-red-500 border-red-600 hover:border-red-500 text-sm border-4 text-white py-1 px-2 rounded ease-in-out duration-500",
        defaultButtonClasses:
          "flex-shrink-0 bg-red-600 hover:bg-red-500 border-red-600 hover:border-red-500 text-sm border-4 text-white py-1 px-2 rounded ease-in-out duration-500"
      };
    },
    components: {
      CopyIcon,
      CheckCircleIcon,
      AlertCircleIcon
    },
    mounted() {
      this.axios
        .get("https://ipv4.izoox.com/tools/ipv4")
        .then(response => {
          this.address = response.data;
        })
        .catch(error => {
          this.address = "No IPv4 Found...";
        });
    },
    methods: {
      onCopy: function (e) {
        this.copied = true;
        this.buttonClasses =
          "flex-shrink-0 bg-green-500 hover:bg-green-400 border-green-500 hover:border-green-400 text-sm border-4 text-white py-1 px-2 rounded ease-in-out duration-500";
        setTimeout(() => {
          this.copied = null;
          this.buttonClasses = this.defaultButtonClasses;
        }, 3000);
      },
      onError: function (e) {
        this.copied = false;
        this.buttonClasses =
          "flex-shrink-0 bg-yellow-500 hover:bg-yellow-400 border-yellow-500 hover:border-yellow-400 text-sm border-4 text-white py-1 px-2 rounded ease-in-out duration-500";
        setTimeout(() => {
          this.copied = null;
          this.buttonClasses = this.defaultButtonClasses;
        }, 3000);
      }
    }
  };
</script>
